import type { ReactElement } from "react";
import { useState } from "react";

const CHARACTERS_TRESHOLD = 80;

const linesClasses = {
  1: "line-clamp-1",
  2: "line-clamp-2",
  3: "line-clamp-3",
  4: "line-clamp-4",
  5: "line-clamp-5",
  6: "line-clamp-6",
} as const;

const TextReveal = ({
  text,
  showMore,
  threshold = CHARACTERS_TRESHOLD,
  lines = 2,
}: {
  text: string;
  lines?: 1 | 2 | 3 | 4 | 5 | 6;
  showMore: ReactElement;
  threshold?: number;
}) => {
  const [show, setShow] = useState(text.length <= threshold);

  if (show) {
    return text;
  }

  return (
    <div>
      <div className={`${linesClasses[lines]} overflow-hidden text-ellipsis`}>{text}</div>
      <div
        className="text-electric-blue underline cursor-pointer flex-wrap shrink-0"
        onClick={() => setShow(true)}
      >
        {showMore}
      </div>
    </div>
  );
};

export default TextReveal;
